module.exports = __webpack_public_path__ + "static/img/3-03.cfdbe1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/custDetail/3-03.png
// module id = RI4n
// module chunks = 1